package com.lomdaat.ads

import com.lomdaat.ads.api.AdsClient
import com.lomdaat.ads.internal.DefaultAdsClient
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.json.Json

fun createAdsClient(
    baseUrl: String = "https://lap-api.com",
    json: Json = defaultAdsJson(),
): AdsClient = DefaultAdsClient(
    baseUrl = baseUrl,
    json = json,
)

@OptIn(ExperimentalSerializationApi::class)
fun defaultAdsJson(): Json = Json {
    ignoreUnknownKeys = true
    explicitNulls = false
    isLenient = true
}
